<template>
  <div class="card my-4 mx-4">
    <div class="card-header pb-0">
      <h6>Edit Test Drive</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="p-3">
        <Form
          as="form"
          class="form"
          @submit="onSubmit"
          :initial-values="initialData"
          :validation-schema="schema"
          v-slot="{ errors }"
          v-if="testDriveObj"
        >
          <div class="my-4">
            <div class="form-group row">
              <h4>Meta Data</h4>
              <div class="col-md-6">
                <label for="">Meta Title</label>
                <Field
                  name="meta_title"
                  type="text"
                  as="input"
                  class="form-control"
                  v-model="testDriveObj.meta_title"
                  :class="{ 'is-invalid': errors.meta_title }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_title }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Description</label>
                <Field
                  name="meta_description"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="testDriveObj.meta_description"
                  :class="{ 'is-invalid': errors.meta_description }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_description }}
                </div>
              </div>
              <div class="col-md-6">
                <label for="">Meta Keywords</label>
                <Field
                  name="meta_keywords"
                  type="text"
                  as="textarea"
                  class="form-control"
                  v-model="testDriveObj.meta_keywords"
                  :class="{ 'is-invalid': errors.meta_keywords }"
                />
                <div class="invalid-feedback">
                  {{ errors.meta_keywords }}
                </div>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-danger my-2">Submit</button>
          <button
            type="button"
            @click="handleCancel"
            class="btn btn-outline-success my-2 cancel-btn"
          >
            Cancel
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, useForm } from "vee-validate";
import * as yup from "yup";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "Test Drive Edit",
  components: {
    Field,
    Form,
  },
  data() {
    const { setFieldValue } = useForm();
    const schema = yup.object().shape({
      meta_title: yup.string().trim(),
      meta_description: yup.string().trim(),
      meta_keywords: yup.string().trim(),
    });

    const initialData = {
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
    };

    return {
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
      schema,
      initialData,
      setFieldValue,
    };
  },
  computed: {
    ...mapGetters("testDrive", ["testDriveObj", "isLoading"]),
  },
  async mounted() {
    await this.fetchDetail();
    
    // Initialize testDriveObj if it doesn't exist
    if (!this.testDriveObj) {
      this.testDriveObj = {
        meta_title: "",
        meta_description: "",
        meta_keywords: ""
      };
    }
    
    let initData = this.testDriveObj ? _.clone(this.testDriveObj) : {};

    this.initialData = this.testDriveObj
      ? {
          ...initData,
        }
      : this.initialData;

    this.meta_title = this.testDriveObj?.meta_title || "";
    this.meta_description = this.testDriveObj?.meta_description || "";
    this.meta_keywords = this.testDriveObj?.meta_keywords || "";
  },
  methods: {
    async fetchDetail() {
      try {
        await this.$store.dispatch("testDrive/fetchTestDriveDetail", 1);
      } catch (err) {
        console.log(err);
      }
    },
    onSubmit(values) {
      const obj = {
        ...values,
        meta_title: this.testDriveObj.meta_title,
        meta_description: this.testDriveObj.meta_description,
        meta_keywords: this.testDriveObj.meta_keywords,
      };
      console.log("Submission object:", obj);
      this.$store.dispatch("testDrive/put", obj)
        .then(() => {
          this.$swal({
            position: "center",
            icon: "success",
            title: "Test Drive Page has been Updated",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$router.push("/cms");
        })
        .catch(err => {
          console.error("Update failed:", err);
        });
    },
    handleCancel() {
      this.$router.push("/cms");
    },
  },
};
</script>
